export default "__VITE_ASSET__DkFI2Kjp__"